import React from "react"
import { HStack, Input, Stack } from "@chakra-ui/react"
import { Control } from "react-hook-form"
import TextField from "components/ReactHookForm/TextField"
import { LOGO_TEXT_PLACEHOLDER, WalletPassBuilderFormValues } from "./walletPassBuilderTypes"
import { PassBuilderFieldRowLabel } from "./PassBuilderTypography"
import PassBuilderFieldInput from "./PassBuilderFieldInput"
import { FIELD_CONTROL_STACK_SPACING, PASS_BUILDER_FIELD_VARIANT } from "./passBuilderTokens"

const passBuilderInputProps = {
  variant: PASS_BUILDER_FIELD_VARIANT,
  fullWidth: true,
  mb: 0,
} as const

type Props = {
  control: Control<WalletPassBuilderFormValues>
  /** Shown as the value itself while the account name is in use */
  accountName?: string
  disabled?: boolean
}

// Logo text is always static (no dynamic value sources), so there is no
// source selector here — just the text input.
const PassBuilderLogoText = ({ control, accountName, disabled = false }: Props) => (
  <Stack spacing={FIELD_CONTROL_STACK_SPACING}>
    <HStack spacing={0} align="center">
      <PassBuilderFieldRowLabel>Value:</PassBuilderFieldRowLabel>
      <PassBuilderFieldInput>
        {disabled ? (
          <Input
            value={accountName || LOGO_TEXT_PLACEHOLDER}
            variant={PASS_BUILDER_FIELD_VARIANT}
            isDisabled
            isReadOnly
            onChange={() => {}}
          />
        ) : (
          <TextField
            name="logoText"
            control={control as any}
            {...passBuilderInputProps}
          />
        )}
      </PassBuilderFieldInput>
    </HStack>
  </Stack>
)

export default PassBuilderLogoText
